import * as jsonpatch from 'fast-json-patch';

const state = {
  metadataObserver: undefined,
  patchData: true,
  logsPathTimestamp:{},
}

const getters = {
  patchData: state => {
    return state.patchData;
  },
}
const actions = {

  genSnapshot({ state, dispatch, commit }) {
    let diffList = jsonpatch.generate(state.metadataObserver,true);
    let snapshot = diffList.map(i => {return Object.assign({},{ ...i , time : Date.now()}) }).filter(i => i.op != 'test');
    commit('SET_PATH_TIME_STAMP', snapshot );
    if (diffList.length > 0) {
      dispatch("design/snapshot/childSnapshot", {
        diffList,
        snapshot
      }, { root: true }).then(() => {
        dispatch("designIframe/frame/reRenderFrame", {}, { root: true })
      })
    }
  },
  activeSectionChangeParent({ dispatch }, { snapshot, type }) {
    dispatch("parentSnapshot", { snapshot, type });
    setTimeout(() => dispatch("designIframe/frame/reRenderFrame", {}, { root: true }), 200)
  },
  activeSectionChangeParentTicker({ commit }) {
    commit('SET_PATCH_DATA',false);
    setTimeout(() =>   commit('SET_PATCH_DATA',true) , 200)
  },
  addLogs({ dispatch }, log) {
    dispatch("designIFrame/postToParent", {
      func: "snapshot/addLogChildren",
      payload: { log },
    }, { root: true })
  },
  parentSnapshot({state, dispatch}, { snapshot }) {
    jsonpatch.unobserve(this.state.designIframe.metadata, state.metadataObserver)
    if (this.state.designIframe.mode == 'temporary') {
      this.state.designIframe.metadata = jsonpatch.applyPatch(this.state.designIframe.metadata, snapshot).newDocument
    }else {
      try {
        let snapshotTemp = [];
        snapshot.map(item => {
          if(state.logsPathTimestamp && state.logsPathTimestamp[item.path]) {
            const oldObj = state.logsPathTimestamp[item.path];
            if(item.time > oldObj) {
              snapshotTemp.push(item);
              state.logsPathTimestamp[item.path] = item.time ? item.time : Date.now();
            }
          }else {
            snapshotTemp.push(item);
            state.logsPathTimestamp[item.path] = item.time ? item.time : Date.now();
          }
        });
        
        this.state.designIframe.metadata = jsonpatch.applyPatch(this.state.designIframe.metadata, snapshotTemp).newDocument
      } catch (error) {
        dispatch("designIFrame/postToParent", {
          func: "snapshot/patchErrorChildren",
          payload: {},
        }, { root: true })
      }
    }
    this.state.designIframe.metadata = JSON.parse(JSON.stringify(this.state.designIframe.metadata))
    state.metadataObserver = jsonpatch.observe(this.state.designIframe.metadata);
  },
}
const mutations = {
  SET_PATCH_DATA(state, bool) {
    state.patchData = bool
  },
  SET_PATH_TIME_STAMP(state, diff) {
    diff.map(item => 
      state.logsPathTimestamp[item.path] = item.time ? item.time : Date.now()
    );
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};